module.exports = __webpack_public_path__ + "static/media/sc_33_i.1feac842.png";